import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgNotificationComponent } from './pg-notification.component';
import { PgIconModule } from '../pg-icon/pg-icon.module';
import { PgNotificationProjectionModule } from './pg-notification-projection-elements';
import { PgFlagNotificationComponent } from './pg-flag-notification/pg-flag-notification.component';

@NgModule({
  imports: [CommonModule, PgIconModule, PgNotificationProjectionModule],
  declarations: [PgNotificationComponent, PgFlagNotificationComponent],
  entryComponents: [PgFlagNotificationComponent, PgNotificationComponent],
  exports: [
    PgNotificationComponent,
    PgFlagNotificationComponent,
    PgNotificationProjectionModule,
  ],
})
export class PgNotificationModule {}
